import { JobRow } from './JobRow';
import React from "react";

export const Rooms = React.memo(function Rooms({bookingRooms, propertyRooms}) {
    const rooms = [];
    const prs = propertyRooms;
    const bprs = bookingRooms;

    for (const i in prs) {
        let found = false;
        for (const j in bprs) {
            if (bprs[j].room.id === prs[i].id) {
                found = true;
                rooms.push({
                    name: bprs[j].room.name,
                    description: bprs[j].roomtype.description,
                    default: false
                });
            }
        }

        if (!found) {
            // find default roomtype
            const def = prs[i].roomtypes.filter((rt) => {
                return rt.default === true;
            });
            if (def && def.length > 0) {
                rooms.push({
                    name: prs[i].name,
                    description: def[0].roomtype.description,
                    default: true
                });
            }
        }
    }

    const roomInfo = rooms.map((rt, i) => {
        return (
            <div key={ i }>
                { rt.name } - { rt.description }
            </div>
        );
    })

    return <JobRow label="Rooms" value={roomInfo} />
});

